<template>
  <div class="register absolute" style="background:#fff;">
    <div class="shading" style="padding:0 40px;">
      <div
        class="pictrue acea-row row-center-wrapper"
        style="height: 1.22rem;"
      ></div>
      <div class="biaoti">
        <div style="display:flex;align-items:center;justify-content: center;">
          <img
            src="../../assets/images/img/img/logo.png"
            style="width: 120px;height: 120px;border-radius:15px;"
            alt=""
          />
        </div>
        <!-- {{ $t('m.dl_span0') }}！ -->
        <!-- <div style="font-size:13px;color:#999;margin-top:6px;">{{ $t('m.dl_span1') }}</div> -->
      </div>
    </div>

    <div class="register_block">
      <div class="register_block_list" style="margin-top:28px;">
        <country-code-selector
          style="background-color:#fff;"
          :countryCode.sync="value"
        ></country-code-selector>
        <input
          v-model="username"
          :placeholder="$t('m.dl_span2')"
          style="padding-left:10px;"
        />
      </div>
      <div class="register_block_list">
        <input
          v-model="password"
          type="password"
          :placeholder="$t('m.dl_span3')"
        />
      </div>
    </div>
    <!-- <p
        @click="login1"
        style="padding-left:45px; display:inline-block; font-weight:bold;color:red;font-size:15px;line-height:40px;"
      >
        短信登录
      </p> -->

    <div
      class="tip"
      style="padding:0 40px; display: flex;align-items: center;justify-content: space-between; color:#666;margin-top:10px;"
    >
      <!-- <span @click="$router.push({ name: 'RetrievePassword' })" class="" style="font-size:14px;color:#FF4438;">{{ $t('m.dl_span5') }}?</span> -->
      <!-- <span @click="goTo()" style="font-size: 14px;color:#333;">
				{{ $t('m.dl_span01') }}
				<span style="color:#FF4438;">{{ $t('m.dl_span02') }}</span>
			</span> -->
      <!-- <span @click="goTo()" class="" style="font-size: 0.2rem;">立即注册</span> -->
    </div>
    <div style="padding:0 40px">
      <van-button class="register_submit" @click="submit">{{
        $t("m.dl_span6")
      }}</van-button>
      <!-- <div style="display:flex;align-items:center;font-size:12px;color:#999;margin-top:0px;height: 40px;">
				<img src="../../assets/images/new/hongxuan.png" style="width: 15px;height: 15px;margin-right:3px;" alt="" />
				{{ $t('m.dl_span5') }}
			</div> -->
      <!-- <van-button class="register_submit" style="color:#1664FC;background:#dfdfdf;margin-top:20px;" @click="goTo()">注册账号</van-button> -->
    </div>

    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.dl_span12") }}
      </div>
    </div>
    <!-- <div
      v-show="hidshow"
      style="position: fixed; width:100%;bottom:50px;left:0;display:flex;align-items:center;justify-content: center;font-size:13px;color:#777;"
    >
      <img
        src="../../assets/images/bank/f2.jpg"
        style="width: 100%;height: 100px;"
        alt=""
      />
    </div> -->
    <div
      data-v-561126ed=""
      style="border: rgb(255, 98, 65); display: flex; justify-content: center; margin-top: 30px;"
    >
      <a href="#/Register" class="" style="color: rgb(51, 133, 255);"
        ><span style="padding: 0px 5px;">立即注册</span></a
      >
    </div>
    <!--    <div-->
    <!--      style="display:flex;align-items:center;font-size:12px;color:#999;margin-top:10px;height: 40px;justify-content: center;"-->
    <!--    >-->
    <!--      <img-->
    <!--        src="../../assets/images/new/hongxuan.png"-->
    <!--        style="width: 15px;height: 15px;margin-right:3px;"-->
    <!--        alt=""-->
    <!--      />-->
    <!--      {{ $t("m.dl_span24") }}-->
    <!--    </div>-->
    <!-- <div
      v-show="hidshow"
      style="position: fixed; width:100%;bottom:70px;left:0;display:flex;align-items:center;justify-content: center;font-size:13px;color:#777;"
    >
      <img
        src="../../assets/images/yhk/bz.png"
        style="width: 16px;height: 16px;margin-right:5px;"
        alt=""
      />
      中国银保监会实时监管，保障基金交易安全
    </div> -->
  </div>
</template>
<script>
import { login } from "@api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import cookie from "@utils/store/cookie";
import countryCodeSelector from "@components/CodeSelector/components/index";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  components: {
    countryCodeSelector
  },
  data: function() {
    return {
      value: 86,
      kejian: false,
      show: false,
      username: "",
      password: "",
      formItem: 1,
      tuijianm: "",
      docmHeight: document.documentElement.clientHeight,
      showHeight: document.documentElement.clientHeight,
      hidshow: true
    };
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.hidshow = false;
      } else {
        this.hidshow = true;
      }
    }
  },
  mounted: function() {
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })();
    };

    if (window.localStorage.getItem("zhanghao")) {
      this.username = window.localStorage.getItem("zhanghao");
      this.value = window.localStorage.getItem("quhao");
      this.password = window.localStorage.getItem("mima");
    }

    var id = this.$route.query.formItem;
    if (id == 1) {
      this.formItem = 1;
    } else if (id == 2) {
      this.formItem = 2;
    }
    this.tuijianm = this.$route.query.spread;
  },
  methods: {
    goTo() {
      this.$router.push({
        path: "/Register"
      });
    },
    kejianB() {
      this.kejian = !this.kejian;
    },
    async submit() {
      const { username, password } = this;
      try {
        await this.$validator({
          username: [required(required.message("账号"))],
          password: [required(required.message("密码"))]
        }).validate({
          username,
          password
        });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      this.show = true;
      login({
        area: this.value,
        username: this.value + username,
        password,
        system: "android"
      })
        .then(data => {
          this.show = false;
          console.log("login", data);
          let expires_time = new Date().getTime() + 86400 * 1000 - 28800000;
          const datas = {
            token: data.data.data.access_token,
            expires_time: expires_time,
            kf: data.data.data.kf,
            view: data.data.data.view
          };

          window.localStorage.setItem("zhanghao", username);
          window.localStorage.setItem("quhao", this.value);
          window.localStorage.setItem("mima", password);
          this.$store.commit("LOGIN", datas);
          cookie.remove(BACK_URL);
          this.$router.push({
            path: "/user"
          });
        })
        .catch(e => {
          this.show = false;
          console.log(e);
          this.$dialog.error(e.response.data.msg);
        });
    }
  }
};
</script>
<style scoped>
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}
.register_block {
  padding: 0 40px;
}
.register_block_list {
  width: 100%;
  height: 60px;
  padding: 0 0px;
  /* background: #f1f1f3; */
  /* border-radius: 5px; */
  display: flex;
  align-items: center;
  font-size: 14px;

  border-bottom: 1px solid #eee;
}
.register_block_list input {
  line-height: 60px;
  height: 60px;
  width: 100%;
  font-size: 15px;
}
/deep/ .intl-tel-input-container {
  padding-left: 0 !important;
  border-right: 1px solid #eee !important;
  flex-shrink: 0;
}
/deep/ .flag {
  display: none !important;
}
/deep/ .country-name {
  display: none;
}
/deep/ .area-codeNum {
  display: inline-block !important;
  padding: 0 2px 0 0 !important;
  font-size: 15px;
}
.code img {
  width: 100%;
  height: 100%;
}
.biaoti {
  /* text-align: center; */
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
}
.pictrueBox {
  display: none;
}
.whiteBg_bottom {
  display: flex;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  margin-top: 45%;
}
.whiteBg_bottom img {
  width: 20px;
}
.whiteBg_bottom p {
  font-size: 14px;
  color: #999;
}
.whiteBg_bottoms {
  display: flex;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  margin-top: 30%;
}
.whiteBg_bottoms img {
  width: 20px;
}
.whiteBg_bottoms p {
  font-size: 14px;
  color: #999;
}
</style>
